import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Logo from '../../assets/logos'
import Button from '../../components/Button'
import PropTypes from 'prop-types'
import Nav from '../../components/Nav'
import Header from '../../components/Header'
import Footer from '../../components/Footer'

const DefaultLayout = ({
  pageTitle,
  company,
  slidesLink,
  videoLink,
  date,
  role,
  figmaLink,
  children
}) => {

  DefaultLayout.defaultProps = {
    slidesLink: '',
    videoLink: false,
    company: '',
    children: null,
  };

  return (
    <div className="work-layout">
      <Header mini />
      <Container>
        <Row>
          <Col className="work-overview" lg={{ span: 12, offset: 0 }} xl={{ span: 3 }}>
            <header className="work-header">
              {company && (<Logo className="work-logo" name={company} />)}
              <h1 className="work-title">{pageTitle}</h1>
              {(date && role) && (<h5>{date} | {role}</h5>)}
            </header>

            {(slidesLink || videoLink) && (
              <div className="work-actions">

                {videoLink && <Button icon="fa-regular fa-circle-play" link to={videoLink} fancy>3-min presentation</Button>}
                {slidesLink && <Button icon="arrow-up-right-from-square" link to={slidesLink} ghost>Slide Deck</Button> }
                {figmaLink && <Button icon="arrow-up-right-from-square" link to={figmaLink} ghost>Figma Prototype</Button>}
              </div>
            )}

          </Col>
          <Col className="work-content" lg={{ span: 12, offset: 0 }} xl={{ span: 8, offset: 4 }}>
            { children }
          </Col>
        </Row>
        <Row>
          <Footer />
        </Row>
      </Container>
    </div>
  )
}

DefaultLayout.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  company: PropTypes.string,
  slidesLink: PropTypes.string,
  videoLink: PropTypes.bool,
  children: PropTypes.node,
};

export default DefaultLayout;
